var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('api-select',_vm._g(_vm._b({attrs:{"label":_vm.l('pages.all.properties.cashbox'),"api":"cashboxes/list"}},'api-select',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }